import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transactionStatus'
})
export class TransactionStatusPipe implements PipeTransform {
  transform(source: string): string {
    if (source === 'Undefined') {
      return 'Unprocessed';
    } else {
      return source;
    }
  }
}
